import DocumentList1 from "../../views/modules/infrastructure/documents/DocumentsList1";
import infrastructure from "../../views/modules/infrastructure/infrastructure";
import layouts from "../../layout";

export default {
  path: "/infrastructure",
  name: "infrastructure",
  component: infrastructure,
  meta: {
    auth: true
  },
  redirect: {
    name: "infrastructure-document"
  },
  children: [
    {
      path: "documents",
      name: "infrastructure-document",
      component: DocumentList1,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Documents",
        tags: ["infrastructure", "documents"],
        index: true
      }
    }
  ]
};
